import React from 'react';
import { useAuth, type PermissionString } from '@/shared/auth';
import { Alert } from '@mui/material';

interface PermissionGuardProps {
  children: React.ReactNode;
  /**
   * Permission to check in dot notation format: 'resource.action'
   * Examples: 'repairOrders.create', 'users.update', 'customers.read'
   */
  permission: PermissionString;
  fallback?: React.ReactNode;
  hideOnNoPermission?: boolean;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  permission,
  fallback = null,
  hideOnNoPermission = false,
}) => {
  const { sessionUser } = useAuth();

  const hasPermission = sessionUser?.can(permission) ?? false;

  if (!hasPermission) {
    if (hideOnNoPermission) {
      return null;
    }

    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Alert severity="warning" sx={{ m: 2 }}>
        You don't have permission to access this feature.
      </Alert>
    );
  }

  return <>{children}</>;
};
